'use client'

import React from 'react'

const ConfigContext = React.createContext<Config>({
  COMPANY_BRAND: '<COMPANY_BRAND>',
  COMPANY_CONTACT_EMAIL: '<COMPANY_CONTACT_EMAIL>',
  COMPANY_DESCRIPTION: '<COMPANY_DESCRIPTION>',
  COMPANY_DPO_EMAIL: '<COMPANY_DPO_EMAIL>',
  COMPANY_LOGO: '<COMPANY_LOGO>',
  COMPANY_NAME: '<COMPANY_NAME>',
  COMPANY_NUMBER: '<COMPANY_NUMBER>',
  COMPANY_OWNER: '<COMPANY_OWNER>',
  COMPANY_PORTAL_ACTIVATED: false,
  COMPANY_PORTAL_IDENTIFIER: '<COMPANY_PORTAL_IDENTIFIER>',
  COMPANY_PRODUCTS_EMAIL: '<COMPANY_PRODUCTS_EMAIL>',
  COMPANY_TITLE: '<COMPANY_TITLE>',
})

interface Config {
  COMPANY_BRAND: string
  COMPANY_CONTACT_EMAIL: string
  COMPANY_DESCRIPTION: string
  COMPANY_DPO_EMAIL: string
  COMPANY_LOGO: string
  COMPANY_NAME: string
  COMPANY_NUMBER: string
  COMPANY_OWNER: string
  COMPANY_PORTAL_ACTIVATED: boolean
  COMPANY_PORTAL_IDENTIFIER: string
  COMPANY_PRODUCTS_EMAIL: string
  COMPANY_TITLE: string
}

export function ConfigProvider({ children, value }: { children: React.ReactNode, value: any }) {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
}

export function useConfig() {
  return React.useContext(ConfigContext)
}